// ============================================================
// LASER TATTOO REMOVAL AZ (Beauté Solutions) — CENTRAL SITE CONFIG
// EVERY fact on the page lives here. Swap the PLACEHOLDER values
// (practitioner name, credentials, booking URL, address, photos,
// press graphics, before/after cases) with the real ones and the
// whole site updates. Do NOT edit section components for content.
// ============================================================

export const BRAND = {
  name: "Beauté Solutions",
  tagline: "Laser Eyeliner Tattoo Removal",
  bookingUrl: "https://beautesolutions.intakeq.com/booking",
  consultUrl: "https://beautesolutions.intakeq.com/portal",
  consultLabel: "Consult portal",
  bookingLabel: "Free photo consultation",
  bannerLine: "Free online consultations — submit your photos through our booking portal",
};

export const PRACTITIONER = {
  name: "Sherry Corvino",
  credentials: "CEO, BSIT, LC, CMLT, CPCP, LSO",
  title: "Laser Eyeliner & Cosmetic Tattoo Removal Expert",
  eyebrow: "About your specialist",
  heading: "A world expert in laser eyeliner and cosmetic tattoo removal.",
  bio: [
    "Sherry Corvino is considered a world expert in laser eyeliner and cosmetic tattoo removal, with decades of experience in permanent makeup, medical aesthetics, cosmetic tattoo pigments, and laser technology. Over the course of her career she has completed more than 14,000 procedures in the cosmetic industry.",
    "Known for taking on complex and previously treated cases, Sherry developed her proprietary Pinpoint laser removal process for the precise correction and removal of unwanted permanent makeup, with particular expertise in the delicate eye area. Recovery is remarkable — most clients leave looking completely normal within thirty minutes of the procedure. Approximately 90% of her clients travel from outside the state for treatment.",
    "Now based in Western Phoenix, Arizona, Sherry specializes in difficult permanent eyeliner cases — including pigment that has changed color, migrated, aged poorly, or needs to be lightened or removed before correction.",
    "She is also regularly called upon as an expert witness in legal matters involving permanent makeup and laser tattoo removal procedures.",
    "She is also the author of Cosmetic Bodies Beyond the Border — a memoir and practical preparation guide for women considering cosmetic surgery, body transformation, and medical tourism beyond the border.",
  ],
  credentialsChips: [
    "Proprietary Pinpoint laser removal process",
    "Founded New York State's first permanent makeup academy (2019)",
    "Patent holder — innovative makeup design tool (2018)",
    "Practiced in three states, now in Western Phoenix, AZ",
  ],
  photo:
    "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/3cgg6yu4_20230725_121415.webp",
};

export const MEDICAL_DIRECTOR = {
  name: "Dr. Pam Henderson",
  credentials: "MD",
  title: "Medical Director",
  bio: "Dr. Pam Henderson serves as Medical Director, providing medical oversight and supporting the highest standards of safety, patient care, and clinical excellence. With extensive experience in facial aesthetics and cosmetic medicine, Dr. Henderson brings a skilled medical perspective to the practice and a strong understanding of facial anatomy, aesthetic treatments, and patient-centered care.",
  photo:
    "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/9c1outdo_p%20henderson.jpg",
};

export const HERO = {
  eyebrow: "Laser eyeliner tattoo removal · Beauté Solutions",
  titleLines: ["Your eyeliner tattoo,", "gently undone."],
  sub: "Precise laser removal for permanent eyeliner — safety protocols that are the finest in the United States, medical-grade corneal protection at every session, and a free online consultation to start. If your brows need it too, Sherry will assess them in the same session and tell you honestly whether removal is necessary.",
  primaryCta: "Book a free photo consultation",
  secondaryCta: "See how it works",
  trust: ["Corneal shields every session", "The finest protocols in the U.S.", "Free online consultations"],
};

export const STATES_TICKER = {
  label: "Clients have traveled from all over the United States — and beyond",
  states: [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
    "Florida", "Georgia", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
    "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Missouri",
    "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New York",
    "North Carolina", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Texas", "Utah",
    "Washington", "Wisconsin", "Wyoming", "Canada", "Russia",
  ],
};

export const ABOUT_IMAGE = null; // filled at build time from generated asset

export const PROCESS = {
  eyebrow: "The process",
  heading: "Safe for the eye. Ruthless on the ink.",
  steps: [
    {
      n: "01",
      title: "Free photo consultation",
      body: "Submit your photos through the booking portal. You get a personal suitability review, a realistic session plan, and clear pricing — before anything is booked.",
      icon: "camera",
    },
    {
      n: "02",
      title: "Shields & comfort",
      body: "The eye is numbed and protected with laser-proof corneal shields — the medical-standard safety step many providers skip.",
      icon: "shield",
    },
    {
      n: "03",
      title: "Precision laser pass",
      body: "Pigment-targeted laser pulses shatter the tattoo ink into particles your body can clear, while the surrounding skin and lash line stay protected.",
      icon: "zap",
    },
    {
      n: "04",
      title: "Heal & repeat",
      body: "Sessions are spaced roughly 6–8 weeks apart so the skin heals fully, and pigment fades progressively across a series. Recovery is so quick that most clients leave looking normal within thirty minutes.",
      icon: "sparkles",
    },
  ],
  callout: {
    title: "The corneal shield is non-negotiable.",
    body: "Laser light and bare eyes never mix. A hardened eye shield is placed before every session — one part of protocols built to be the finest in the United States. If a provider treats eyeliner without one, walk out. And here's the reassuring part: even though it seems the scariest step, the shield is the simplest part of the entire process.",
  },
};

export const PROVIDER_GUIDE = {
  eyebrow: "How to choose a provider",
  heading: "Five questions to ask before anyone lasers your eyeliner.",
  checklist: [
    { q: "Are corneal shields used every session?", a: "Hard eye shields are the accepted safety standard for laser work near the eye. No shield, no treatment." },
    { q: "Is eyeliner removal a specialty or a side service?", a: "The eyelid is not the place for a generalist's practice run. Look for a provider whose core work is cosmetic tattoo removal around the eyes." },
    { q: "Are the safety protocols written and rigorous?", a: "The best providers document everything — shield placement, laser settings, spacing between sessions. These protocols should be the standard, not an afterthought." },
    { q: "Is the technology pigment-specific?", a: "Cosmetic inks — especially titanium-oxide whites that can darken — need correct wavelengths and settings, not one-size-fits-all power." },
    { q: "Can they show real before & afters?", a: "Ask for unretouched, consistent-lighting photos of their own eyeliner cases, with session counts." },
  ],
  redFlags: {
    title: "Instant walk-out red flags",
    items: [
      "No corneal eye shields",
      "One setting for every skin type and ink color",
      "Missing or vague safety protocols",
    ],
  },
};

export const NEWS = {
  eyebrow: "Press",
  heading: "In the News",
  note: "Sherry's expertise has been featured in",
  items: [
    {
      id: "buffalo-news-areola",
      image: "/press/buffalo-news-areola.jpg",
      outlet: "The Buffalo News",
      date: "October 7, 2016",
      headline: "Areola tattoo a major marker on WNY women's cancer recovery",
    },
    {
      id: "buffalo-magazine-about-face",
      image: "/press/buffalo-magazine.jpg",
      outlet: "Buffalo Magazine",
      date: "March 2, 2016",
      headline: "About face: Trending cosmetic procedures",
    },
    {
      id: "national-womens-magazines",
      image: "/press/national-magazines.jpg",
      outlet: "Good Housekeeping · Woman's Day · Redbook",
      date: "2021",
      headline: "Full-service makeover spa helps clients look and feel their best",
    },
    {
      id: "rochester-woman",
      image: "/press/rochester-woman.jpg",
      outlet: "Rochester Woman Online",
      date: "December 3, 2019",
      headline: "Sherry Hale: The brains behind the Beaute",
    },
    {
      id: "buffalo-news-bladeless",
      image: "/press/buffalo-news-bladeless.jpg",
      outlet: "The Buffalo News",
      date: "November 14, 2016",
      headline: "Why is bladeless safer than microblading? — by Sherry Hale",
    },
  ],
};

export const BEFORE_AFTER = {
  eyebrow: "Results",
  heading: "Before & after",
  sub: "Real client cases, straight from the treatment room. Some sessions can take up to four visits, while other people are done in one — it all depends on the saturation level and the type of ink that's used.",
  cases: [
    {
      id: "titan-xl-2-sessions",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/yaq8suv1_V2.webp",
      title: "Titan XL — laser eyeliner tattoo removal",
      sessions: "2 removal sessions · actual result, not retouched",
      alt: "Titan XL laser eyeliner tattoo removal after two sessions, actual result not retouched",
    },
    {
      id: "eyeliner-3-sessions-hd",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/cvf7cop0_01%20%281%29.webp",
      title: "Laser eyeliner tattoo removal",
      sessions: "3 removal sessions",
      alt: "Before and after of laser eyeliner tattoo removal after three sessions",
    },
    {
      id: "eyeliner-1-session-hd",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/wrh6z429_Post-Design%20%282%29.webp",
      title: "Laser tattoo eyeliner removal",
      sessions: "Healed after 1 removal session",
      alt: "Before and after of eyeliner tattoo removal, healed after one session",
    },
    {
      id: "migration-off-shape",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/bj35azvw_precision%20removal.png",
      title: "Precision laser tattoo removal — migration off shape",
      sessions: "Before & immediately after treatment",
      alt: "Grey migrated eyeliner tattoo before and immediately after precision laser removal",
    },
    {
      id: "migrated-eyeliner-1",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/cmnzln15_2022%20Precision%20Laser%20Migrated%20Eyeliner%20Removal%20-%2001a.png",
      title: "Precision laser migrated eyeliner removal",
      sessions: "Immediately after — 1 session",
      alt: "Migrated eyeliner tattoo immediately after one precision laser session",
    },
    {
      id: "eyeliner-3-sessions",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/1z9auxt9_01%20%281%29.webp",
      title: "Laser eyeliner tattoo removal",
      sessions: "3 removal sessions",
      alt: "Before and after of laser eyeliner tattoo removal after 3 sessions",
    },
    {
      id: "eyeliner-1-healed",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/1f0zxz3t_Post-Design%20%282%29.webp",
      title: "Laser tattoo eyeliner removal",
      sessions: "Healed after 1 removal session",
      alt: "Before and after of eyeliner tattoo removal, healed after one session",
    },
    {
      id: "brow-eyeliner-1",
      image: "/case-brow-eyeliner.jpg",
      title: "Laser brow and eyeliner tattoo removal",
      sessions: "1 session · 1 hour post-recovery — eyelid spots too",
      alt: "Before and after of brow and eyeliner tattoo removal one hour after a single session",
    },
    {
      id: "brow-1-session",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/6mym18a4_Post-design-2-1.webp",
      title: "Brow laser tattoo removal",
      sessions: "Immediately after 1 session",
      alt: "Before and after of brow laser tattoo removal immediately after one session",
    },
    {
      id: "removal-correction",
      image:
        "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/bl6qe6oq_Post-design-%281%29.jpg-F.webp",
      title: "Laser tattoo removal and correction",
      sessions: "Finished with 3D hairstroke brows",
      alt: "Grey eyebrow tattoo removed and corrected with 3D hairstroke brows",
    },
  ],
  cta: "Start with your free photo review",
};

export const FAQ = {
  eyebrow: "Good questions",
  heading: "Frequently asked questions",
  items: [
    { q: "Is laser eyeliner removal safe for my eyes?", a: "When performed with proper laser-proof corneal shields and trained hands, the laser never touches the eye itself. Shielding and ocular safety are the core of every protocol here — refined over more cases of eyeliner removal than most providers see in a career." },
    { q: "Does it hurt?", a: "The area is numbed before treatment and the sensation is often described as quick, warm flicks along the lash line. Most clients find sessions very manageable, and the eyelid heals quickly between sessions." },
    { q: "How will I look when I leave?", a: "Better than you'd expect. You can wash your face normally, and you'll switch to a fresh pair of contacts the next day — wear glasses the day of your treatment.\n\nBefore you leave, we can apply makeup by Jane Iredale — a mineral line that cannot hold bacteria, so it's safe to put on right away. If you'd like to purchase anything in the store, or leave with your makeup on, we're happy to do it." },
    { q: "How many sessions will I need?", a: "It all depends on the saturation level and the type of ink that's used. Some people are done in a single session, while others need up to four visits. Your free photo consultation gives you a realistic estimate for your specific eyeliner." },
    { q: "Can you remove old blue or grey eyeliner?", a: "Yes — discolored cosmetic pigment is common and is addressed by adjusting laser wavelengths and settings. Old ink sometimes responds differently, which is exactly why your photos are reviewed before treatment." },
    { q: "How does the free online consultation work?", a: "Use the booking link at the top of the page, submit clear photos of your eyeliner tattoo, and you receive a personal assessment, a session plan and pricing — with no obligation." },
    { q: "Will my lashes be affected?", a: "The laser targets pigment in the skin along the lash line, not the follicles. Lash protection and proper shielding are part of every session protocol." },
    { q: "What kind of laser do you use?", a: "The specific brand or model of laser is far less important than the expertise of the person operating it. You may hear terms such as Pico and Nano used when discussing tattoo removal lasers — these terms primarily describe the speed at which the laser delivers its energy: picoseconds versus nanoseconds.\n\nWe do not disclose the specific equipment or combination of technologies used in our treatments, as our equipment selection, techniques, and treatment protocols are proprietary to Laser Tattoo Removal AZ.\n\nWe are also the pioneers of our exclusive Precision Removal technique, a specialized approach developed through years of experience in laser tattoo and permanent makeup removal. This technique is unique to our practice and is not offered by other laser tattoo removal providers.\n\nUltimately, the laser is only a tool — the expertise, knowledge, and technique of the person operating it are what produce exceptional results." },
    { q: "What if my ink doesn't come out?", a: "Some permanent makeup pigments can be extremely resistant to laser treatment. For stubborn eyebrow pigment that is not responding as expected, we may recommend our Magnetic Removal Process.\n\nThis specialized non-laser technique gives us an additional option for resistant brow pigment when laser treatment alone is not achieving the desired result.\n\nMagnetic Removal is used for eyebrows only. It is not performed on eyeliner." },
    { q: "What makes your safety protocols different?", a: "Everything we do is written, documented and followed to the letter — corneal shield placement, laser settings for your exact skin and ink, healing timelines, session spacing. Nothing is left to memory or guesswork.\n\nAnd the documentation is only half of it. The treatment process and the safety of our facility are held to the same uncompromising standard: a calm, controlled clinical space where every instrument, every surface and every session is held to the highest level of care. Even the medical directors we have worked with throughout our careers are always impressed by how high our protocol standards are.\n\nBecause exceptional results are never an accident — they are protocols, process and facility working together, every client, every session, every time." },
  ],
};

export const VISIT = {
  eyebrow: "Visit",
  heading: "Come see us — or start with a photo.",
  note: "Booking is our only point of contact, so every enquiry gets a proper consultation instead of a rushed phone call.",
  address: {
    street: "9823 W Northern Ave, Suite 125",
    city: "Peoria",
    state: "AZ",
    zip: "85345",
    formatted: "My Salon Suites, 9823 W Northern Ave, Suite 125, Peoria, AZ 85345 (Inside Park West Plaza on Northern Ave)",
  },
  flyingIn: "Flying in? Most clients can fly in and home the same day if they have a single flight — it's about a 30 to 40-minute Uber each way from Phoenix Sky Harbor International Airport (PHX). Others may need to stay the night. Please plan for about five hours between your landing time and your departure.",
  bookingNote: "Booking is our only point of contact — the phone line is for information only, so every enquiry gets a proper consultation.",
  phone: "602-609-4341",
  phoneNote: "Information only — to book an appointment, please use the booking button above.",
  mapEmbedUrl:
    "https://maps.google.com/maps?q=Beaute%20Solutions%2C%209823%20W%20Northern%20Ave%20Ste%20125%2C%20Peoria%2C%20AZ%2085345&t=&z=16&ie=UTF8&iwloc=&output=embed",
};

export const ACCREDITATIONS = {
  eyebrow: "Accreditations & affiliations",
  note: "More affiliations coming soon",
  items: [
    {
      id: "cb-monogram",
      image: "/accreditations/cb-monogram.png",
      alt: "Custom Beauté CB monogram",
      dark: true,
    },
    {
      id: "cpcp",
      image: "/accreditations/cpcp.png",
      alt: "Certified Permanent Cosmetic Professional seal",
    },
    {
      id: "azdhs",
      image: "/accreditations/azdhs.png",
      alt: "Arizona Department of Health Services",
    },
    {
      id: "az-seal",
      image: "/accreditations/az-seal.png",
      alt: "Great Seal of the State of Arizona",
    },
    {
      id: "azccc",
      image: "/accreditations/azccc.png",
      alt: "Arizona Center for Cancer Care",
    },
    {
      id: "az-cosmetology",
      image: "/accreditations/az-cosmetology.png",
      alt: "Arizona State Board of Cosmetology",
    },
    {
      id: "shale-group",
      image: "/accreditations/shale-group.png",
      alt: "The Shale Group",
    },
  ],
  reserve: 0,
};

export const PAYMENTS = {
  label: "We accept",
  cards: [
    { id: "visa", image: "/cards/visa.png", alt: "Visa accepted" },
    { id: "mastercard", image: "/cards/mastercard.png", alt: "Mastercard accepted" },
    { id: "discover", image: "/cards/discover.png", alt: "Discover accepted" },
    { id: "amex", image: "/cards/amex.png", alt: "American Express accepted" },
    { id: "hsa", image: "/cards/hsa.png", alt: "Healthcare Spending Account accepted" },
    { id: "fsa", image: "/cards/fsa.png", alt: "Flexible Spending Account debit card accepted" },
  ],
  reserve: 2,
};

export const REVIEWS = {
  heading: "What clients say",
  sub: "Real Google reviews from real laser eyeliner removal clients.",
  items: [
    {
      id: "myrna-davis",
      name: "Myrna Davis",
      meta: "4 reviews · a year ago",
      text: "I had a botched eyeliner tattoo for 4 years leaving me very insecure — all that went away within an hour, thanks to Sherri!! Extremely grateful for her expertise in this field. I drove 3 hours to see her and would do it again! For those thinking you can find someone more experienced, knowledgeable and cheaper — STOP LOOKING! There's no one better than Sherri. She is worth every penny!! Thank you Sherri!!",
    },
    {
      id: "lily-rodriguez",
      name: "Lily Rodriguez M.",
      meta: "Local Guide · 17 reviews · 2 years ago",
      text: "Sherry Corvino was absolutely amazing! I found her through a YouTube video that someone posted with their experience with Sherry. I did my research and chose her to remove the migrated ink from a bad permanent eyeliner procedure. I was so blessed to have been able to travel from deep south Texas to Scottsdale AZ and have Sherry work her magic! I highly recommend her! If you are able to meet with her, don't waste time! It's life changing!",
    },
    {
      id: "trinh-dieu",
      name: "Trinh Dieu",
      meta: "3 reviews · 2 years ago",
      text: "Sherry is wonderful, and I knew I was in good hands. I travelled from New Orleans, Louisiana to Phoenix. I am so happy with the results — and with tears of joy after my procedure to remove my permanent eyeliner. I am so blessed to have found Sherry through YouTube. After a few days, my eyes have healed quickly and look more open and refreshed. Thank YOU Sherry for taking good care of me.",
    },
    {
      id: "raina-strieck",
      name: "Raina Strieck",
      meta: "7 reviews · 2 years ago",
      text: "Sherry is wonderful! I traveled from Washington to see her for tattoo eyeliner removal, migration. She explained the procedure and what to expect. She made the process very comfortable. She was able to remove the migration and soften the bottom liner. It was definitely worth traveling to see her. I would highly recommend her to anyone.",
    },
    {
      id: "sasa-daily",
      name: "Sasa Daily",
      meta: "5 reviews · 3 years ago",
      text: "Sherry is very professional, cares about your wellbeing and has state of the art equipment. She exhibits finesse when doing her procedures. I recently had permanent tattoo eyeliner removed by her using laser. The outcome is the best! I'm beyond happy that I found her and recommend her without hesitation.",
    },
    {
      id: "pam-torgrimson",
      name: "Pam Torgrimson",
      meta: "3 reviews · 2 years ago",
      text: "20 years ago I thought it would be a great idea to have permanent eyeliner tattooed. As I aged, I did not like the way my eyeliner looked anymore. I started researching laser eyeliner removal and I found Sherry's reviews and I knew she was the one I wanted to do the procedure. For some reason or another (probably fear), I decided to wait. Fast forward to the next year — I was shocked to see she opened a second location in Scottsdale. Where I live!!! I would have flown to New York because I…",
    },
    {
      id: "lisa-briggs",
      name: "Lisa Briggs",
      meta: "4 reviews · 3 years ago",
      text: "Sherry is amazing! Very detailed and a perfectionist. I've gotten my eyebrows done and they look amazing! She also removed my old eyeliner and did fiberblast around my eyes. Sherry knows her stuff and is an amazing woman. So glad I found her!",
    },
    {
      id: "may-szeto",
      name: "May Szeto",
      meta: "4 reviews · 3 years ago",
      text: "I am so glad I found Sherry to remove my eyeliner & eyebrow colors. The colors turned blue and I didn't feel confident with them for a long time. I feel great after removing them even though they still have some colors left. I'll go back to Sherry to redo my eyebrows even though I have to fly from California. I also love all the skin products she recommended me to use.",
    },
    {
      id: "lynn-collette",
      name: "Lynn Collette",
      meta: "2 reviews · 3 years ago",
      text: "I have been a client of Custom Beauty, now Beauty Solutions, for many, many years. Sherry has done several procedures for me including thermaderm upper and lower face procedure, permanent eyeliner, and three times micro needling brows with several years in between appointments. My most recent visit was last week and I will go back again when needed. Sherry is very talented and professional and I don't hesitate to recommend her 100%!",
    },
    {
      id: "amanda-middleton",
      name: "Amanda Middleton",
      meta: "4 reviews · 2 years ago",
      text: "Sherry is amazing! Very knowledgeable about the services she offers. I have not seen myself without tattooed eyeliner for over 20 years. She explained things through the entire process of the removal, so I was comfortable and understood what was happening. I am so excited!",
    },
    {
      id: "inge-bertram",
      name: "Inge Bertram",
      meta: "3 reviews · 2 years ago",
      text: "Sherrie was just fantastic with my eyeliner removal. No one would touch eyeliner removal and she did an amazing job! She also removed and \u201cresculptured\u201d my eyebrows! Just beautiful!!!!",
    },
    {
      id: "laila-pickard",
      name: "Laila Pickard",
      meta: "7 reviews · 3 years ago",
      text: "Shari is amazing. Had my old permenant eyeliner partially removed. Looks great now. Her skincare line is fantastic. My skin looks so much better. Will be seeing Shari for all my skincare needs in the future!",
    },
  ],
};

export const VIDEOS = {
  heading: "The removal in motion",
  sub: "Watch real laser eyeliner removal sessions — up close.",
  items: [
    {
      id: "video-lisa",
      title: "Laser eyeliner removal — Lisa's session",
      embed: "https://www.youtube-nocookie.com/embed/8CkOli6WniM",
    },
    {
      id: "video-emily",
      title: "Emily's removal experience",
      embed: "https://www.youtube-nocookie.com/embed/KP1GS1bGl8w",
    },
  ],
};

export const BEYOND = {
  eyebrow: "From our founder",
  heading: "Before you travel abroad for cosmetic surgery, read this.",
  quote: "The honest guide she couldn't find before she flew.",
  body: "Sherry's authority isn't just professional — it's personal. After losing over 100 pounds, she faced more than ten skin removal surgeries of her own, and she traveled beyond the border for cosmetic surgery firsthand. Her memoir and practical guide pack that journey into the honest prep she couldn't find before she flew: the right questions, the real risks, and how to take your next step with complete peace of mind.",
  cta: "Get the book now",
  url: "https://mycosmeticsbeyond.com",
  bookImage:
    "https://d64gsuwffb70l.cloudfront.net/6a4a5e8167fa91adc64bfd6c_1783333184236_8534ac45.webp",
  portraitImage:
    "https://d64gsuwffb70l.cloudfront.net/6a4a5e8167fa91adc64bfd6c_1783333482706_9b31ea56.webp",
};

export const FOOTER = {
  disclaimer: "Content on this site is educational and is not medical advice. Candidacy, session counts and results are confirmed at consultation. Results vary from person to person.",
};
